import React from "react";
import { motion } from "framer-motion";

export const ShimmerButton = ({ children, onClick, className = "", ...props }) => {
  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.98 }}
      onClick={onClick}
      className={`
        relative overflow-hidden
        bg-warm-rose text-white
        px-8 py-4 rounded-full
        font-sans font-semibold text-lg
        shadow-[0_8px_20px_rgba(212,165,165,0.4)]
        hover:shadow-[0_12px_30px_rgba(212,165,165,0.5)]
        transition-shadow duration-300
        ${className}
      `}
      data-testid="shimmer-button"
      {...props}
    >
      <span className="relative z-10">{children}</span>
      <span
        className="absolute inset-0 -translate-x-full hover:animate-shimmer bg-gradient-to-r from-transparent via-white/30 to-transparent"
        style={{
          animation: "none"
        }}
      />
      <motion.span
        className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
        initial={{ x: "-100%" }}
        whileHover={{
          x: "100%",
          transition: { duration: 1, repeat: Infinity, repeatDelay: 0.5 }
        }}
      />
    </motion.button>
  );
};

export default ShimmerButton;
